module.exports = __webpack_public_path__ + "img/dark-footer-3.5eab77aa.png";